import { gql } from '@apollo/client';

export const GENERATE_WORK_PROGRESS_BAG_PARCEL_DOWNLOAD_REPORT = gql`
  mutation GenerateWorkProgressBagParcelDownloadReport(
    $filter: WorkProgressBagParcelExportFilterInput!
    $timezone: String
  ) {
    generateWorkProgressBagParcelDownloadReport(filter: $filter, timezone: $timezone)
  }
`;

export interface GenerateWorkProgressBagParcelDownloadReportResponse {
  generateWorkProgressBagParcelDownloadReport: string;
}

export interface WorkProgressBagParcelExportFilterInput {
  hubId: number;
  arrivalDateStart: string;
  arrivalDateEnd: string;
  bagNumber?: string | null;
  customerId?: number | null;
  mawb?: string | null;
  bagType?: 0 | 1 | null;
  isInbound?: boolean | null;
  inboundBagOnly?: boolean | null;
  parcelNumbers?: string[] | null;
}

export interface GenerateWorkProgressBagParcelDownloadReportVariables {
  filter: WorkProgressBagParcelExportFilterInput;
  timezone?: string;
}

